export const ADD_NEW_EQUIPMENT = 'ADD_NEW_EQUIPMENT';
export const FETCH_ALL_EQUIPMENTS = 'FETCH_ALL_EQUIPMENTS';
export const GET_FREE_EQUIPMENT = 'GET_FREE_EQUIPMENT';
export const CALL_ALL_EQUIPMENTS = 'CALL_ALL_EQUIPMENTS';
export const SINGLE_SELECT_EQUIPMENT = 'SINGLE_SELECT_EQUIPMENT';

const setAddNewEquipment = data =>
({
    type: ADD_NEW_EQUIPMENT,
    payload: { data },
});

const setGetAllEquiments = data =>
({
    type: FETCH_ALL_EQUIPMENTS,
    payload: { data },
});

const setGetFreeEquipment = data =>
({
    type: GET_FREE_EQUIPMENT,
    payload: { data },
});

const setFetchEquipment = data =>
({
    type: CALL_ALL_EQUIPMENTS,
    payload: { data },
});

const setSingleEquipment = data =>
({
    type: SINGLE_SELECT_EQUIPMENT,
    payload: { data },
});

//GET FROM DISPATCH
export const showAddNewEquipmentModal = data => async dispatch => {
    try {
        dispatch(setAddNewEquipment(data));
    } catch (error) {
        console.log(error);
    }
};

export const getAllEquipments = data => dispatch => {
    dispatch(setGetAllEquiments(data));
};

export const getAllFreeEquipments = data => dispatch => {
    dispatch(setGetFreeEquipment(data));
};

export const FetchAllEquipment = data => dispatch => {
    dispatch(setFetchEquipment(data));
};

export const singleEquipment = data => dispatch => {
    dispatch(setSingleEquipment(data));
};